import { render, staticRenderFns } from "./SalesStatus.vue?vue&type=template&id=4d5cd12a"
import script from "./SalesStatus.vue?vue&type=script&lang=js"
export * from "./SalesStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports